import React, { useState } from 'react'
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import reinvite from "../../../../styles/svg/reinvite.svg";
import CustomMenuItem from '../../../../components/Menu/CustomMenuItem';
import FormDialog from '../../../../components/Dialog/FormDialog';
import { Typography } from '@mui/material';
import { inviteExternalUser } from '../../../../services/apiUser';
import useMutate from '../../../../hooks/useMutate';

function ResendInvite({ params }) {
    const [open, setOpen] = useState(false);

    const { mutate, isPending } = useMutate(
        inviteExternalUser,
        ["users"],
        () => {
            handleClose();
        },
        () => {
            handleClose();
        }
    );

    const handleResendInvite = () => {
        mutate({
            first_name: params.row.first_name,
            last_name: params.row.last_name,
            email: params.row.email,
        });
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {open && (
                <FormDialog
                    open={open}
                    handleClose={handleClose}
                    isLoading={isPending}
                    handleSubmit={handleResendInvite}
                    buttonTxt="Resend"
                    cancelBtn={true}
                    alignActions={"center"}
                    fullWidth={true}
                    isHeader={false}
                >
                    <div className="resend-invite-confirmation">
                        <ErrorOutlineOutlinedIcon className="confirmation-icon" />
                        <Typography className="resend-invite-confirmation-title">
                            Resend invitation?
                        </Typography>
                        <Typography className="resend-invite-confirmation-description">
                            An email will be sent to the user’s email address.
                        </Typography>
                    </div>
                </FormDialog>
            )}
            <CustomMenuItem onClick={() => setOpen(true)} disabled={isPending}>
                <img src={reinvite} className="mr-3" />
                Resend Invitation
            </CustomMenuItem>
        </>
    );
}

export default ResendInvite;
